// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"245":"lazy","508":"dev"}[chunkId] + "." + {"245":"30d4918c","508":"3fb0e5b2"}[chunkId] + ".css";
};